import { inject, Injectable } from '@angular/core';

import { Observable, tap } from 'rxjs';

import { ENVIRONMENT } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';
import { FeatureCode } from '@recruitee/http-types';

import { FeatureSpecFetchResponse } from './feature-spec.types';

const validateResponse = (data: any, printToConsole: boolean) => {
  if (!data.features || !Array.isArray(data.features)) {
    throw new Error('Invalid response');
  }
  const { features } = data;
  const responseKeys: string[] = features.map((feature: any) => feature.codename);
  Object.values(FeatureCode).forEach((key: string) => {
    if (!responseKeys.includes(key) && printToConsole) {
      console.warn(`Feature ${key} is missing in the response`);
    }
  });

  return data;
};

@Injectable({ providedIn: 'root' })
export class FeatureSpecHttpClient {
  private environment = inject(ENVIRONMENT, { optional: true });
  constructor(protected httpApi: HttpApiService) {}

  public fetch(): Observable<FeatureSpecFetchResponse> {
    return this.httpApi
      .get('/features/spec')
      .pipe(
        tap(response =>
          validateResponse(response, this.environment?.environmentName !== 'production'),
        ),
      );
  }
}
